import { ISectionContainerProps } from "component-library";

import { IEditVideoFormContent } from "./components/EditVideoForm/EditVideoFormContent";

export interface IEditVideoPageContent {
  header: string;
  closeButton: string;
  saveButton: string;
  cancelButton: string;
  cancelPopup: {
    cancelPopupCloseButtonText: string;
    cancelPopupDescription: string;
    cancelPopupTitle: string;
    continueEditingButtonText: string;
  };
  editVideoForm: IEditVideoFormContent;
}

export const IEditVideoPageContentKeys = [
  "header",
  "closeButton",
  "saveButton",
  "cancelButton",
  "cancelPopup",
  "editVideoForm",
];

export const getSectionContainerProps = (
  content: IEditVideoPageContent,
  handleCloseClick: () => void = () => undefined
): ISectionContainerProps => {
  return {
    header: content.header,
    variant: "shadowed",
    controls: [
      {
        text: content.closeButton,
        onClick: handleCloseClick,
      },
    ],
  };
};
